import { render, staticRenderFns } from "./ProductVersions.vue?vue&type=template&id=42b1619c&scoped=true"
import script from "./ProductVersions.vue?vue&type=script&lang=ts"
export * from "./ProductVersions.vue?vue&type=script&lang=ts"
import style0 from "./ProductVersions.vue?vue&type=style&index=0&id=42b1619c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1619c",
  null
  
)

export default component.exports